export interface GLLineItem {
  description: string;
  amount: number;
  glAccountNumber: string;
  jobNumber: string | null;
}

export interface Invoice {
  tracking_id: string;
  vendor_number: number | null;
  vendor_name: string;
  invoice_number: string;
  invoice_date: string;
  invoice_amount: number;
  calculated_total: number | null;          // DB nullable
  gl_line_items: GLLineItem[];
  corrected_gl_line_items: GLLineItem[] | null;
  status: string;
  document_type: string;
  workflow_type: string;
  is_reconciled: boolean;
  is_credit: boolean;
  job_number: string | null;                // DB nullable
  job_name: string | null;                  // DB nullable
  company_number: number | null;            // DB nullable (default 1)
  payment_method_id: number | null;         // DB nullable
  credit_card_vendor_number: number | null;  // FK → ap_credit_cards.cc_vendor_number
  posting_date: string | null;
  correction_notes: string | null;
  source_email_subject: string | null;
  source_filename: string | null;
  source_blob_path: string | null;
  received_at: string;
  // These come from JOIN with invoice_tokens, not from ap_invoice_payloads directly
  expires_at: string | null;
  used_at: string | null;
}

// Real column names from ap_gl_accounts
export interface GLAccount {
  gl_number: string;
  description: string;
  account_type: string;
}

export interface Job {
  job_number: string;
  job_name: string;
  job_address: string | null;
  job_city: string | null;
  job_state: string | null;
  job_zip: string | null;
}

export interface CreditCard {
  cc_vendor_number: number;  // ap_credit_cards.cc_vendor_number — WinTeam vendor# for CC routing
  description: string;
  is_default: boolean;
  active: boolean;
}

export interface HeaderEdits {
  invoice_amount: number;
  invoice_date: string;
  invoice_number: string;        // editable invoice/credit number
  payment_method_id: number;
  credit_card_vendor_number: number | null;
  posting_date: string;
  vendor_number: number | null;  // null until reviewer assigns (OTHER invoices only)
  vendor_name: string;
}

export const PAYMENT_METHODS: { id: number; label: string }[] = [
  { id: 1, label: 'Check' },
  { id: 2, label: 'Credit Card' },
  { id: 3, label: 'ACH / NACHA' },
  { id: 4, label: 'Wire Transfer' },
];